<template>
  <div class="row">
    <div class="login">
      <div class="col-12 col-md-4 offset-md-4">
        <center><h5>Đăng ký</h5></center>
        <div class="mt-4">
          <p>Chào bạn !</p>
          <p class="mt-3">Đây là phần mềm Cố vấn phong thuỷ , hoạt động như một trợ lý ảo về tâm linh, được phát triển
          dựa trên cổ học của người xưa(phong thuỷ, bát tự, tử vi, kinh dịch...) và trí tuệ nhân tạo máy tính.</p>
          <p class="mt-3">Nó chỉ dành cho bạn và chỉ đúng với riêng Bạn. Vì thế Bạn cần khai báo trung thực những thông
          tin dưới đây để hệ thống có thể phần tích và cố vấn cho Bạn một cách chính xác nhất.</p>
        </div>

      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <div class="text-left mt-2"><b>Nhập thông tin để đăng ký</b></div>
        <form
          class="mt-2">
          <div class="form-group">
            <input
              v-model="user.full_name"
              type="text"
              class="form-control"
              placeholder="Họ và tên">
          </div>
          <div class="form-group">
            <select
              v-model="user.sex"
              class="form-control">
              <option>Giới tính</option>
              <option value="1">Nam</option>
              <option value="1">Nữ</option>
              <option value="3">Không xác định</option>
            </select>
          </div>
          <div class="form-group">
            <input
              v-model="user.email"
              type="email"
              class="form-control"
              placeholder="Email của bạn">
          </div>
          <div class="form-group">
            <input
              v-model="user.phone"
              type="text"
              class="form-control"
              placeholder="Số điện thoại">
          </div>
          <div class="form-group">
            <input
              v-model="user.birth_day"
              type="date"
              class="form-control"
              placeholder="Ngày sinh của bạn">
          </div>
          <div class="form-group">
            <input
              v-model="user.password"
              type="password"
              class="form-control"
              placeholder="Mật khẩu mới">
          </div>
          <div class="form-group">
            <input
              v-model="user.c_password"
              type="password"
              class="form-control"
              placeholder="Nhập lại mật khẩu">
          </div>
          <button
            type="button"
            class="btn btn-order bg-green mt-4"
            @click="signUp">Tiếp tục
          </button>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'

  export default {
    name: 'SignUp',
    data () {
      return {
        user: {
          birth_day: '',
          email: '',
          facebook_id: '',
          full_name: '',
          phone: '',
          sex: '',
          password: '',
          c_password: ''
        }
      }
    },
    mounted () {
      this.reset()
    },

    methods: {
      reset () {
        this.user.birth_day = ''
        this.user.email = ''
        this.user.facebook_id = ''
        this.user.full_name = ''
        this.user.phone = ''
        this.user.sex = ''
        this.user.password = ''
        this.user.c_password = ''
      },

      signUp() {
        rf.getRequest("UserRequest").signUp(this.user).then((res) => {
          if (res.status === 200) {
            this.$router.push("/otp");
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/SignUp.vue